import dayjs from 'dayjs'
import { randomId } from '@mui/x-data-grid-generator'

export const getNewMaterial = () => {
  const rowId = randomId()

  return {
    id: rowId,
    materialTypeId: null,
    materialType: {
      materialTypeId: null,
      commonName: '',
    },
    wip: 0,
    wipCost: 0,
    wipAvgCost: 0,
    newWip: 0,
    newWipCost: 0,
    wipChange: 0, // SEND THIS TO THE BACKEND
    wipCostChange: 0, // SEND THIS TO THE BACKEND
    wipAvgCostChange: 0,
    materialWasUpdated: false,
  }
}

export const formatData = data => ({
  effectiveDate: dayjs(data?.effectiveDate).toISOString(),
  notes: data.notes,
  materials: data.materials
    .filter(m => !!m.materialTypeId)
    .map(material => ({
      materialTypeId: material?.materialType?.materialTypeId,
      netWeight: material?.wipChange,
      netCost: material?.wipCostChange,
    })),
})
